<template>

  <div>
    <transition name="fade">
      <component
        v-if="currentComponent"
        :is="currentComponent"
        v-bind="currentComponentProps"
        @next-element="onNextElement"
      />
    </transition>

    <div class="sidebar-content">
      <side-bar-menu
        class="left-panel-elements"
        :class="{'open':showPanelElements}"
      />
      <ThreeCanvas key="threeCanvasMain" />
    </div>

  </div>

</template>

<script>
import ThreeCanvas from "../../components/Client/ThreeCanvas.vue";
import SideBarMenu from "../../components/Client/SideBarMenu.vue";
import ElementsSidebar from "../../components/Client/ElementsSidebar.vue";
import Ogradi from "../../components/Client/Ogradi.vue";
import Pages from "../../components/Client/Pages.vue";
import Plots from "../../components/Client/Plots.vue";
import Landscaping from "../../components/Client/Landscaping.vue";
import ThreeSceneEngraving from "../../components/Client/ThreeSceneEngraving.vue";

export default {
  components: {
    ThreeCanvas,
    SideBarMenu,
    ElementsSidebar,
    Plots,
    Ogradi,
    Pages,
    Landscaping,
    ThreeSceneEngraving,
  },

  methods: {
    goNextElement(nextElement) {
      this.$store.dispatch("clientMain/setManageElement", null);
      this.$store.dispatch("clientMain/setManageElement", nextElement);
    },
    onNextElement(nextElement) {
      if (nextElement) {
        this.goNextElement(nextElement);
      }
    },
  },
  computed: {
    manageElement() {
      return this.$store.state.clientMain.manageElement;
    },
    currentComponent() {
      switch (this.manageElement) {
        case "plot":
          return "Plots";
        case "landscaping":
          return "Landscaping";
        case "barrier":
          return "Ogradi";
        case "pages":
          return "Pages";
        case "stely":
        case "tumby":
        case "vazy":
        case "stoliki":
        case "skameiki":
        case "cvetniki-nadgrobiya":
          return "ElementsSidebar";
        default:
          return null;
      }
    },
    currentComponentProps() {
      if (
        this.manageElement === "stely" ||
        this.manageElement === "tumby" ||
        this.manageElement === "vazy" ||
        this.manageElement === "stoliki" ||
        this.manageElement === "skameiki" ||
        this.manageElement === "cvetniki-nadgrobiya"
      ) {
        return { element_group: this.manageElement };
      }
      return {};
    },
    faces() {
      return this.$store.state.clientOrder.faces;
    },
    showPanelElements() {
      return this.$store.state.clientMain.showPanelElements;
    },
  },
  name: "Index",
};
</script>

<style scoped>
@media screen and (max-width: 1000px) {
  .sidebar-content {
    grid-template-columns: auto;
  }
  .left-panel-elements {
    position: fixed;
    z-index: 30;
    background-color: #fff;
    left: -9999px;
    transition: left 0.4s;
    overflow-y: scroll;
    top: 40px;
    bottom: 0;
  }
  .left-panel-elements.open {
    left: 0;
  }
}
</style>



